import { useEffect } from 'react';
import { Outlet, useSearchParams } from 'react-router';

const CustomerProposalPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const appointmentProposalId = searchParams.get('appointmentProposalId');

  useEffect(() => {
    if (token && appointmentProposalId) {
      const base = '/proposal-presentation';
      const newSearchParams = new URLSearchParams({
        token,
        appointmentProposalId,
      });
      window.location.replace(`${base}?${newSearchParams}`);
    }
  }, [token, appointmentProposalId]);

  return <Outlet />;
};

export default CustomerProposalPage;
